import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { firstValueFrom } from 'rxjs'

import { AuthService } from '../../../shared/services/auth.service'
import { HelperService } from '../../../shared/services/helper.service'
import { VpnBlockedService } from '../../vpn-blocked/vpn-blocked.service'

export const authGuard: CanActivateFn = async () => {
	const router = inject(Router)
	const helperService = inject(HelperService)
	const authService = inject(AuthService)
	const vpnBlockedService = inject(VpnBlockedService)
	const token = helperService.getUserData()?.access_token

	if (token) {
		return true
	}

	helperService.clearUserData()

	try {
		const loginResponse = await firstValueFrom(authService.demoLogin())
		authService.setUserDataAfterLogin(loginResponse)
		return true
	} catch (error: unknown) {
		const httpError = error as { status?: number; error?: { code?: string } }
		if (httpError?.status === 403 && (httpError.error?.code === 'VPN_DETECTED' || httpError.error?.code === 'VPN_BLOCKED')) {
			if (httpError.error) {
				vpnBlockedService.setVpnInfo(httpError.error)
			}
			return router.parseUrl('/vpn-blocked')
		}
		return router.parseUrl('/maintenance')
	}
}
